export const DEFAULT_X_AXIS_KEY = 'DEFAULT_X_AXIS_KEY';
export const DEFAULT_Y_AXIS_KEY = 'DEFAULT_Y_AXIS_KEY';
export const DEFAULT_MARGINS = {
  top: 50,
  bottom: 50,
  left: 50,
  right: 50
};